import React, { createContext, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    nav_home: "Home", nav_about: "About Us", nav_programs: "Programs", nav_gallery: "Gallery",
    nav_internships: "Internships", nav_tests: "Test Series", nav_contact: "Contact",
    nav_donate: "Donate Now", nav_login: "Login", nav_dashboard: "My Dashboard",
    hero_badge: "Bihar's Trusted NGO Platform",
    hero_title_1: "Empowering Lives,", hero_title_2: "Building Futures",
    hero_donate: "Donate Now", hero_join: "Join Us", hero_watch: "Watch Story",
    trust_80g: "80G Certified", trust_darpan: "NGO Darpan Verified", trust_sec8: "Section 8 Company",
    lives_impacted: "Lives Impacted", volunteers: "Volunteers", districts: "Districts", funds_raised: "Funds Raised",
    programs_title: "Our Programs", about_title: "About Us",
    stay_connected: "Stay Connected",
    ready_cta: "Ready to Make a Difference?",
    top_80g: "80G Tax Benefit Available",
    footer_quick: "Quick Links", footer_legal: "Legal Information", footer_contact: "Contact",
    footer_privacy: "Privacy Policy", footer_terms: "Terms & Conditions", footer_refund: "Refund Policy",
  },
  hi: {
    nav_home: "होम", nav_about: "हमारे बारे में", nav_programs: "कार्यक्रम", nav_gallery: "गैलरी",
    nav_internships: "इंटर्नशिप", nav_tests: "टेस्ट सीरीज़", nav_contact: "संपर्क",
    nav_donate: "दान करें", nav_login: "लॉगिन", nav_dashboard: "मेरा डैशबोर्ड",
    hero_badge: "बिहार का विश्वसनीय एनजीओ मंच",
    hero_title_1: "जीवन को सशक्त बनाना,", hero_title_2: "भविष्य का निर्माण",
    hero_donate: "अभी दान करें", hero_join: "हमसे जुड़ें", hero_watch: "वीडियो देखें",
    trust_80g: "80G प्रमाणित", trust_darpan: "एनजीओ दर्पण सत्यापित", trust_sec8: "धारा 8 कंपनी",
    lives_impacted: "प्रभावित जीवन", volunteers: "स्वयंसेवक", districts: "जिले", funds_raised: "जुटाई गई राशि",
    programs_title: "हमारे कार्यक्रम", about_title: "हमारे बारे में",
    stay_connected: "जुड़े रहें",
    ready_cta: "क्या आप बदलाव लाने के लिए तैयार हैं?",
    top_80g: "80G कर छूट उपलब्ध",
    footer_quick: "त्वरित लिंक", footer_legal: "कानूनी सूचना", footer_contact: "संपर्क",
    footer_privacy: "गोपनीयता नीति", footer_terms: "नियम एवं शर्तें", footer_refund: "वापसी नीति",
  },
};

const I18nContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => {
    if (typeof window !== "undefined") return localStorage.getItem("pmr_lang") || "en";
    return "en";
  });
  const setLang = (l) => {
    setLangState(l);
    if (typeof window !== "undefined") localStorage.setItem("pmr_lang", l);
    if (typeof document !== "undefined") document.documentElement.lang = l;
  };
  useEffect(() => {
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);
  const t = (key) => (dict[lang] && dict[lang][key]) || dict.en[key] || key;
  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
